var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leak-reviewed-table-cell"},[_c('custom-checkbox',{attrs:{"color":"cold-marine","size":"s","value":_vm.reviewedValue},on:{"input":_vm.updateReviewedValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }